import { generateNonConformityReport } from "../NonCons/reports.js";

export const subNonConformityReport = context => generateNonConformityReport(context, {
    "reportTitle": "Sub-NonConformity Report",
    "filenamePrefix": "SubNonConformityReport"
});
